export const paperProps = { mt: 2, pb: 3, px: 2, borderRadius: "25px" };
export const paperResponsiveStyle = { ...paperProps, mx: { xs: 2, md: 0 } };
export const containerResponsiveStyle = { px: { xs: 2, md: 0 } };
export const systemRowPaperProps = { pb: 3, px: 2, borderRadius: "15px" };
